/**
 * This file was created to be an easier API than focusRing.ts.
 * It'll do some math so you don't need to.
 *
 * It's split out so we don't have to upgrade the whole repo and can move components over to
 * this one over time.
 */

import { color } from "@smartsheet/design-tokens-react";
import { themed } from "@smartsheet/sds-theme-internal";
import { focus } from "../constants/colors";
export var focusRingTheme = themed({
  outerColor: {
    "lodestar-light": focus,
    oldestar: "#0073ec",
    "ursa-light": color("focus-indicator--border-primary")
  },
  innerColor: {
    "lodestar-light": "transparent",
    oldestar: "transparent",
    "ursa-light": color("focus-indicator--border-secondary")
  }
});

// TODO look into outline-color: none and using multiple box-shadows instead of a border color on :before?

export var createFocusRingStyles = function createFocusRingStyles(_ref) {
  var colorOverride = _ref.colorOverride,
    innerColorOverride = _ref.innerColorOverride,
    theme = _ref.theme,
    gap = _ref.gap,
    componentBorderWidth = _ref.componentBorderWidth,
    componentRadius = _ref.componentRadius,
    componentRadiusOverride = _ref.componentRadiusOverride,
    _ref$ringWidth = _ref.ringWidth,
    ringWidth = _ref$ringWidth === void 0 ? 2 : _ref$ringWidth,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? "relative" : _ref$position,
    _ref$pseudoElement = _ref.pseudoElement,
    pseudoElement = _ref$pseudoElement === void 0 ? "before" : _ref$pseudoElement,
    _ref$focusSelector = _ref.focusSelector,
    focusSelector = _ref$focusSelector === void 0 ? ":focus" : _ref$focusSelector,
    _ref$secondaryWidth = _ref.secondaryWidth,
    secondaryWidth = _ref$secondaryWidth === void 0 ? 1 : _ref$secondaryWidth;
  // This needs to be a negative number so we'll subtract all of these from 0.
  var borderOffset = "calc(0px - ".concat(px(gap), " - ").concat(px(ringWidth), " - ").concat(px(componentBorderWidth), ")");

  // If this is a string, assume the calculations are already done. Otherwise, calculate the radius.
  var outerBorderRadius = componentRadiusOverride || "calc(".concat(px(componentRadius), " + calc(").concat(px(gap), " + ").concat(px(ringWidth), " ))");
  return "\n        & {\n            position: ".concat(position, ";\n            outline: none;\n        }\n\n        &").concat(focusSelector, " {\n            outline: none;\n        }\n\n        &").concat(focusSelector, "::").concat(pseudoElement, " {\n            content: \"\";\n            display: block;\n            \n            position: absolute;\n            inset: ").concat(borderOffset, ";\n\n            border: ").concat(ringWidth, "px solid ").concat(colorOverride || focusRingTheme.outerColor(theme), ";\n            border-radius: ").concat(outerBorderRadius, ";\n\n            pointer-events: none;\n\n            box-shadow: inset 0 0 0 ").concat(secondaryWidth, "px ").concat(innerColorOverride || focusRingTheme.innerColor(theme), ";\n        }\n    ");
};
var px = function px(input) {
  return typeof input === "string" ? input : "".concat(input, "px");
};
//# sourceMappingURL=createFocusRingStyles.js.map